import { render, staticRenderFns } from "./PRO_EMSummary.vue?vue&type=template&id=84227ae6&scoped=true&"
import script from "./PRO_EMSummary.vue?vue&type=script&lang=js&"
export * from "./PRO_EMSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84227ae6",
  null
  
)

export default component.exports